import React from "react";

import { OffersBody } from "@src/features/offers/Offers.body";

export const OffersRoute = () => {
  return <OffersBody />;
};
